/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid"; // Import UUID generator
import { useNetwork } from "../../NetworkProvider";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/fr"; // Import the French locale
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import { DialogActions, Button } from "@mui/material";

import FastAPIClient from "../../../client";
import config from "../../../config";
const client = new FastAPIClient(config);

import { FormattedMessage, IntlProvider } from "react-intl";
import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";

const messages = {
    en: messages_en,
    fr: messages_fr,
};

// import { fr } from "date-fns/locale";

import { FiCalendar } from "react-icons/fi";
import Throbber from "../../../style/Throbber";

dayjs.locale("fr"); // Set the locale globally

const ReminderModal = ({ userId, setReminderToggle, clientId, locale }) => {
    const { isOnline } = useNetwork();
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [reminderData, setReminderData] = useState({
        reminder_id: uuidv4(),
        start_date: null,
        user_id: userId, // Replace with the user's ID if applicable
        title: "",
        comment: "",
    });

    const handleChange = (e) => {
        if (e && e.target) {
            // Handle text inputs
            const { name, value } = e.target;
            setReminderData((prevData) => ({ ...prevData, [name]: value }));
        } else {
            // Handle MUI DatePicker (e is a Day.js object)
            setReminderData((prevData) => ({
                ...prevData,
                start_date: e ? dayjs(e).format("YYYY-MM-DD") : null, // Convert to YYYY-MM-DD
            }));
        }
    };

    const [titleError, setTitleError] = useState(false);
    const [dateError, setDateError] = useState(false);

    const handleSaveReminder = async (e) => {
        setIsSubmitting(true);
        e.preventDefault();

        let isValid = true;
        let newError = null; // To track the error message

        if (!reminderData.title) {
            setTitleError(true);
            // newError = "report.title_required"; // Set an error key
            isValid = false;
        } else {
            setTitleError(false);
        }

        if (!reminderData.start_date) {
            setDateError(true);
            // newError = "report.date_required"; // Set an error key
            isValid = false;
        } else {
            setDateError(false);
        }

        if (!isValid) {
            setError(newError); // Set the error state to trigger the message display
            setIsSubmitting(false);
            return;
        }

        let offlineParams = {};

        if (!isOnline) {
            offlineParams = { created_at: new Date().toISOString() };
        }

        const reminder = {
            reminder_id: reminderData.reminder_id,
            date: new Date(reminderData.start_date).toISOString(),
            title: reminderData.title,
            user_id: userId,
            note: reminderData.comment,
            client_id: clientId,
            ...offlineParams,
        };
        await client.createReminder(reminder);
        setError(null); // Clear error on success
        setSuccess("report.success");
        setTimeout(() => {
            setSuccess(null);
            setReminderToggle(false);
        }, 1000);
        setIsSubmitting(false);
    };

    const closeModal = () => {
        setReminderToggle(false);
    };
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50 h-full">
            <IntlProvider locale={locale} messages={messages[locale]}>
                {error && (
                    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-2 rounded">
                        <FormattedMessage id={error} values={{ number: 1 }} />
                    </div>
                )}

                {success && (
                    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded">
                        <FormattedMessage id={success} values={{ number: 1 }} />
                    </div>
                )}

                <div className="bg-white p-6 rounded-t-2xl md:rounded-2xl shadow-md md:w-1/2 md:max-w-[80%] h-2/3 absolute bottom-0 w-full md:relative animate-slide-up pt-4 flex flex-col">
                    <div className="flex flex-row w-full items-center mb-4 relative">
                        <div className="flex w-10 h-10 bg-gray-100 ml-2 rounded-full items-center justify-center">
                            <FiCalendar />
                        </div>
                        <div>
                            <h2 className="text-xl ml-4">
                                <FormattedMessage
                                    id="report.plan"
                                    values={{ number: 1 }}
                                />
                            </h2>
                        </div>
                        {isSubmitting && (
                            <div className="absolute top-1/2 left-1/2 z-10">
                                <Throbber />
                            </div>
                        )}
                    </div>

                    <form
                        onSubmit={(e) => handleSaveReminder(e)}
                        className="text-lg flex flex-col h-full"
                    >
                        <div className="flex items-center mb-2">
                            <label className="w-1/3 pr-2 text-left hidden md:block">
                                Date:
                            </label>
                            <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                                adapterLocale="fr"
                            >
                                <DatePicker
                                    label="Sélectionner une date"
                                    value={
                                        reminderData.start_date
                                            ? dayjs(reminderData.start_date)
                                            : null
                                    }
                                    onChange={handleChange}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            error: dateError,
                                            helperText: dateError
                                                ? "Veuillez sélectionner une date"
                                                : "",
                                            InputProps: {
                                                sx: {
                                                    borderRadius: "10px",
                                                    padding: "0px",
                                                    paddingRight: "20px",
                                                    "& .MuiOutlinedInput-notchedOutline":
                                                        {
                                                            borderColor: "#ccc",
                                                        },
                                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                                        {
                                                            borderColor: "#aaa",
                                                        },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                        {
                                                            borderColor: "#000",
                                                        },
                                                },
                                            },
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                    DialogProps={{
                                        actions: (
                                            <>
                                                <DialogActions>
                                                    <Button
                                                        onClick={closeModal}
                                                        color="primary"
                                                    >
                                                        Annuler
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            /* handle save */
                                                        }}
                                                        color="primary"
                                                    >
                                                        Ok
                                                    </Button>
                                                </DialogActions>
                                            </>
                                        ),
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex items-center mb-2">
                            <label className="w-1/3 pr-2 text-left hidden md:block">
                                Objet:
                            </label>
                            <TextField
                                fullWidth
                                name="title"
                                value={reminderData.title}
                                onChange={handleChange}
                                label="Entrez la raison"
                                variant="outlined"
                                error={titleError}
                                helperText={
                                    titleError ? "Veuillez entrer un titre" : ""
                                }
                                sx={{
                                    borderRadius: "50px",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        padding: "0px",
                                        "& fieldset": { borderColor: "#ccc" },
                                        "&:hover fieldset": {
                                            borderColor: "#aaa",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#000",
                                        },
                                    },
                                }}
                            />
                        </div>
                        <div className="flex items-center mb-2 text-left">
                            <label className="w-1/3 pr-2 hidden md:block">
                                Commentaires:
                            </label>
                            <TextField
                                fullWidth
                                name="comment"
                                value={reminderData.comment}
                                onChange={handleChange}
                                label="Entrez un commentaire"
                                variant="outlined"
                                multiline
                                minRows={3}
                                sx={{
                                    borderRadius: "50px",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        padding: "10px",
                                        "& fieldset": { borderColor: "#ccc" },
                                        "&:hover fieldset": {
                                            borderColor: "#aaa",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#000",
                                        },
                                    },
                                }}
                            />
                        </div>
                        <div className="flex flex-grow"></div>

                        <div className="flex flex-row w-full text-base mt-auto mb-10">
                            <div className="w-1/2 hidden md:block"></div>
                            <div className="flex justify-center gap-10 py-3 w-full md:w-1/2 px-20">
                                <button
                                    onClick={() => closeModal()}
                                    className="md:w-full hover:bg-gray-100 rounded-full px-3 text-black pl pr pt-1 pb-1 font-semibold md:align-right"
                                >
                                    <FormattedMessage
                                        id="report.cancel"
                                        values={{ number: 1 }}
                                    />
                                </button>
                                <button
                                    type="submit"
                                    className="md:w-full bg-gold text-black rounded-full px-3 pt-1 pb-1 font-semibold md:align-right disabled:bg-gray-300"
                                    disabled={isSubmitting}
                                >
                                    <FormattedMessage
                                        id="report.save"
                                        values={{ number: 1 }}
                                    />
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </IntlProvider>
        </div>
    );
};

export default ReminderModal;
